import React from 'react';
import { getEnv } from '@adsk/acs-sc-web-platform-api';
import { LaunchDarklyProvider } from '../../LaunchDarklyContext';
import { CurrentProjectIdProvider, CurrentAccountIdProvider, ProjectEntitlementsProvider, } from '@adsk/alloy-provider';
export var LaunchDarklyProviderWrapper = function (_a) {
    var projectId = _a.projectId, children = _a.children;
    var LDApiKeys = {
        development: '5f8760c7af41f80bfbccd463',
        QA: '5f8760c7af41f80bfbccd460',
        STAGING: '5f8760c6af41f80bfbccd45d',
        PRODUCTION: '5f8760c5235a4e0b61e953a4',
    };
    var LDApiKey = process.env.NODE_ENV === 'development'
        ? LDApiKeys['development']
        : LDApiKeys[getEnv()];
    return (React.createElement(CurrentProjectIdProvider, { projectId: projectId },
        React.createElement(ProjectEntitlementsProvider, null,
            React.createElement(CurrentAccountIdProvider, null,
                React.createElement(LaunchDarklyProvider, { apiKey: LDApiKey }, children)))));
};
